import iconSelect from "./icon-select";
export default iconSelect;
export const base = 'https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/assets/icons/';
